import { z } from 'zod';
/** The two kinds of secret that travel by email. Both single-use, both hashed at rest. */
export const ACCOUNT_TOKEN_PURPOSES = ['verify', 'reset'];
/**
 * Length only. Composition rules push people towards `Passw0rd!` and towards
 * writing it down; a long password is the one thing that reliably helps.
 */
export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 200;
const password = z.string().min(MIN_PASSWORD_LENGTH).max(MAX_PASSWORD_LENGTH);
/** Addresses are compared and stored lowercased, so they are normalised on the way in. */
const email = z.string().trim().toLowerCase().email().max(254);
export const registerSchema = z.object({
    email,
    password,
    name: z.string().trim().min(1).max(80).optional(),
});
export const signInSchema = z.object({ email, password: z.string().min(1) });
/** Used by both "resend my verification" and "I forgot my password". */
export const emailOnlySchema = z.object({ email });
export const verifyTokenSchema = z.object({ token: z.string().min(1).max(64) });
export const resetPasswordSchema = z.object({ token: z.string().min(1).max(64), password });
export const createOwnedSessionSchema = z.object({ name: z.string().trim().min(1).max(80) });
/**
 * Claiming takes either the token or the whole control-panel link, because what a
 * host actually has to hand is the link they were given.
 */
export const claimSessionSchema = z
    .object({
    adminToken: z.string().trim().min(1).max(200).optional(),
    adminUrl: z.string().trim().min(1).max(500).optional(),
})
    .refine((v) => Boolean(v.adminToken ?? v.adminUrl), {
    message: 'Provide a control panel link',
});
//# sourceMappingURL=account.js.map